/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsCommentingUnitChanged, setTempCommentingUnitConfig } from 'state/slices/commentingv2'
// material
import ConfigV2Controller from 'material/expandablesection/v2/configv2controller/configv2controller'
import ExpandableSection from 'material/expandablesection/expandablesection'
import { ReactComponent as BoardActivity } from 'assets/icons/board-activity.svg'
// content
import Placements from './placements/placements';
// styles
import injectSheet from 'react-jss'
import styles from './adssection_styles'
import AdDetails from './addetails/addetails';
import { updateAdsConfig } from 'state/thunks/commenting';
import Preview from './preview/preview';
import Space from 'material/space/space';
import Visibility from './visibility/visibility';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADS SECTION ~~~~~~~~~~ ========== */
const AdsSection = injectSheet(styles)((props) => {
  
  const dispatch = useDispatch()
  const { siteUUID } = useSelector((state) => state.session)
  const { adsConfig: savedAdsConfig, status} = useSelector(state => state.commentingV2.commentingUnitConfig)
  const { adsConfig: tempAdsConfig } = useSelector(state => state.commentingV2.tempCommentingUnitConfig)

  const [adsConfig, setAdsConfig] = useState(savedAdsConfig)
  const [isOpened, setIsOpened] = useState(false)
  const [selectedPlacementVersion, selectPlacementVersion] = useState('desktop')

  const [isScollIntoView, setIsScrollIntoView] = useState(false)

  useEffect(() => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if(hasCommentAnchor && (status === 'fulfilled' || status === 'rejected')) setIsOpened(true)
  },[status])

  useEffect(() => {
    if(isOpened && !isScollIntoView) scrollToComment()
  }, [isOpened, isScollIntoView])

  const scrollToComment= () => {
    let currentLocation = window.location.href;
    const hasCommentAnchor = currentLocation.includes("?view=adsConfig");
    if (hasCommentAnchor) {
      // fixHeaderPosition()
      const anchorComment = document.getElementById('ads-config');
      if(anchorComment){
        // anchorComment.style.scrollMargin = '100px';
          setTimeout(() => {
            anchorComment.scrollIntoView({ behavior: "smooth",  block: 'center'  })
            setIsScrollIntoView(true)
          }, 700)
      }
    }
  }
  

  // useEffect(() => {
  //   if(adsConfig !== savedAdsConfig && !isOpened) setAdsConfig(savedAdsConfig)
  // }, [savedAdsConfig, isOpened, adsConfig])

  const handleToggle = () => setIsOpened(!isOpened)

  const handleSave = useCallback(async (e) => {
    e.stopPropagation()
    const response = await dispatch(updateAdsConfig({ adsConfig: {...adsConfig, siteUUID } }))
    if(response.payload && !response.payload.error) setIsOpened(false)
  }, [adsConfig, dispatch, siteUUID])

  const handleCancel = useCallback(async () => {
    setIsOpened(false)
    setAdsConfig(savedAdsConfig)
    dispatch(setTempCommentingUnitConfig({
      configName: 'adsConfig',
      data: savedAdsConfig
    }))
  }, [dispatch, savedAdsConfig])

  const isChanged = useMemo(() => {
    const isFieldsChanged = !(JSON.stringify(tempAdsConfig) === JSON.stringify(savedAdsConfig));
    return isFieldsChanged
  }, [tempAdsConfig, savedAdsConfig])


  const handleAdsConfigChange = useCallback((property, value) => {
    const version = selectedPlacementVersion === 'desktop' ? 'desktopConfig' : 'mobileConfig'
    setAdsConfig({
      ...adsConfig,
      [version]: {
        ...adsConfig[version],
        [property]: value,
      }
    })

    dispatch(setTempCommentingUnitConfig({
      configName: 'adsConfig',
      data: {
        ...adsConfig,
        [version]: {
          ...adsConfig[version],
          [property]: value,
        }
      }
    }))
}, [adsConfig, dispatch, selectedPlacementVersion]);

  const controller = (
    <ConfigV2Controller
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={savedAdsConfig.isUpdating}
      disableSave={!isChanged}
      saveTitle={'Save Changes'}
      icon={<BoardActivity />}
      title='Ads'
    />
  );

  const selectedConfig = adsConfig[selectedPlacementVersion === 'desktop' ? 'desktopConfig' : 'mobileConfig']


  return (
    <ExpandableSection
      className={`expandablesectionv2 adssection ${props.classes.adssection}`}
      controller={controller}
      isOpened={isOpened}
      handleToggle={handleToggle}
      handleCancel={handleCancel}
      handleSave={handleSave}
      isProcessing={savedAdsConfig.isUpdating}
      disableSave={!isChanged}
    >
      <Space>
        <Space direction={'column'} gap={48}>
          <Visibility {...selectedConfig} onChange={handleAdsConfigChange} />
          <Placements 
            version={selectedPlacementVersion} 
            selectVersion={selectPlacementVersion} 
            onChange={handleAdsConfigChange} 
            {...selectedConfig}  
          />
          <AdDetails {...selectedConfig} />
        </Space>
        <Preview version={selectedPlacementVersion} selectVersion={selectPlacementVersion} {...selectedConfig} />
      </Space>
    </ExpandableSection>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdsSection